import React from 'react';

import { SVGComponentProps } from './svg.types';

const StarSVG = ({ stroke = 'currentColor', size = '0.9em', ...otherProps }: SVGComponentProps) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...otherProps}
    >
      <g clipPath="url(#clip0_1530_52190)">
        <path
          d="M9.13313 4.60201L9.25327 4.85546L9.53219 4.88504L13.1242 5.26604L13.1242 5.26606L13.1286 5.2665C13.2115 5.27454 13.2902 5.3071 13.3545 5.36003C13.4188 5.41296 13.4658 5.48385 13.4897 5.56366C13.5135 5.64346 13.513 5.72856 13.4882 5.80808C13.4635 5.8876 13.4156 5.95794 13.3507 6.01012L13.3507 6.01009L13.3464 6.01363L10.4824 8.36863L10.2448 8.56394L10.312 8.86403L11.198 12.823L11.1981 12.8236C11.2162 12.9038 11.2102 12.9876 11.181 13.0645C11.1518 13.1413 11.1006 13.2079 11.0338 13.2559C10.967 13.3038 10.8876 13.3311 10.8054 13.3343C10.7233 13.3374 10.642 13.3163 10.5718 13.2737C10.5718 13.2737 10.5717 13.2736 10.5717 13.2736L7.25981 11.2587L7.00011 11.1007L6.74032 11.2585L3.42564 13.2723C3.42558 13.2724 3.42551 13.2724 3.42544 13.2724C3.3551 13.315 3.27378 13.3361 3.19159 13.3329C3.10933 13.3297 3.02981 13.3024 2.96293 13.2544C2.89605 13.2064 2.84475 13.1398 2.81541 13.0629C2.78612 12.986 2.78001 12.9023 2.79785 12.8221C2.79788 12.822 2.7979 12.8218 2.79793 12.8217L3.68775 8.86452L3.75529 8.56416L3.51749 8.36863L0.653494 6.01363L0.653501 6.01362L0.651035 6.01162C0.586576 5.9593 0.539113 5.88901 0.514668 5.80967C0.490223 5.73033 0.4899 5.64552 0.513737 5.56599C0.537575 5.48647 0.5845 5.41582 0.648558 5.36301C0.712615 5.31019 0.790918 5.2776 0.873529 5.26937L0.87353 5.26938L0.876682 5.26904L4.46768 4.88804L4.74669 4.85844L4.8668 4.60487L6.62056 0.902379C6.62058 0.902337 6.6206 0.902294 6.62062 0.902252C6.65471 0.830554 6.70842 0.769985 6.77553 0.727568C6.84268 0.685126 6.92049 0.662598 6.99993 0.662598C7.07937 0.662598 7.15718 0.685126 7.22433 0.727568C7.29148 0.77001 7.34521 0.830626 7.3793 0.902379L9.13313 4.60201Z"
          stroke={stroke}
        />
      </g>
      <defs>
        <clipPath id="clip0_1530_52190">
          <rect width="14" height="14" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default StarSVG;
